import React from 'react'
import styled from '@emotion/styled'

import { Line } from '../generic/Basics'
import { breakpoints } from '../../constants'
import { BrowserUtils } from '../../utils/siteUtils'

const ICOSLPCarImage = __PATH_PREFIX__ + '/Landing/ICOSLPCarImage.png'
const Gradient = __PATH_PREFIX__ + '/Landing/Gradient.png'
const ExplicitImgSize = isLarge => (isLarge ? { width: 478, height: 200 } : { width: 287, height: 120 })

export default ({ experience, showVechileImageOnLandingPage, dealerIsDirectToKBBv2 }) => {
  if (dealerIsDirectToKBBv2) {
    return <StyledSell2KbbV2Div></StyledSell2KbbV2Div>
  }

  let isLarge
  if (BrowserUtils.isBrowser) {
    isLarge = window && window.matchMedia && window.matchMedia(`(min-width: ${breakpoints.lg}px)`).matches
  }
  const { width, height } = ExplicitImgSize(isLarge)

  return experience === 'kbb' && showVechileImageOnLandingPage !== 'none' ? (
    <StyledBackgroundDiv>
      <img src={ICOSLPCarImage} alt={'Kelley Blue Book'} width={width} height={height} />
    </StyledBackgroundDiv>
  ) : (
    <Line width={65} />
  )
}

const StyledBackgroundDiv = styled.div`
  width: 100%;
  background-image: url(${Gradient});
  background-repeat: no-repeat;
  background-position-y: 80px;
  background-position-x: center;
  display: flex;
  justify-content: center;
  background-size: contain;
  padding-bottom: 16px;

  @media (min-width: ${breakpoints.lg}px) {
    background-position-y: 125px;
  }
`
const StyledSell2KbbV2Div = styled.div`
  margin-top: 45px;
`
